/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";

export const LineLightmodeCheck4 = ({ color = "#14142B", className }) => {
  return (
    <svg
      className={`line-lightmode-check-4 ${className}`}
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="path"
        d="M4 12.3136L9.65685 17.9704L20.9706 6.65674"
        stroke={color}
        strokeLinecap="round"
        strokeWidth="2"
      />
    </svg>
  );
};

LineLightmodeCheck4.propTypes = {
  color: PropTypes.string,
};
